import { useEffect, useState } from 'react';
import { getSyncState, watchSyncState, type SyncState } from '../../data/syncState';

const LABELS: Record<SyncState['status'], (state: SyncState) => string> = {
  synced: () => 'Synced',
  // What is at stake, not what the radio is doing.
  pending: () => 'Not yet saved to the server',
  offline: () => 'Offline',
};

/**
 * The global half of WD-04.
 *
 * Global state alone would say *something* is unsynced without saying what, which on a
 * financial record is the wrong half of the information — the per-row marker on the
 * transaction list is the other half, and arrives with M3.
 */
export function SyncIndicator() {
  const [state, setState] = useState<SyncState>(getSyncState);

  useEffect(() => watchSyncState(setState), []);

  return (
    <span className="sync" data-status={state.status} title={LABELS[state.status](state)}>
      <span className="dot" aria-hidden="true" />
      {/* The dot alone carries the state on a phone, where topbar width is scarce.
          The text stays in the title, so it is never lost — only deferred. */}
      <span className="sync-text">{LABELS[state.status](state)}</span>
    </span>
  );
}
